import { motion } from 'framer-motion';
import { useAuth } from '../../hooks/useAuth';
import teryWave from '../../../public/tery/tery_wave.png';
import { EASE_OUT } from '@/lib/motion';

const WelcomeBanner: React.FC = () => {
  const { user } = useAuth();

  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, ease: EASE_OUT }}
      className="relative overflow-visible rounded-2xl bg-gradient-to-r from-secondary-400 via-primary-500 to-primary-700 dark:from-secondary-600 dark:via-primary-600 dark:to-primary-800 min-h-[192px] flex items-center text-banner-ink"
      data-testid="welcome-banner"
    >
      {/* Mascot — pinned to bottom-left, natural aspect ratio */}
      <div className="absolute bottom-0 left-4 w-[220px] pointer-events-none select-none">
        <img src={teryWave} alt="" className="h-[210px] drop-shadow-lg" />
      </div>

      {/* Text */}
      <div className="ml-[300px] py-10 pr-8">
        <p className="text-[20px] leading-[28px] font-normal opacity-90">Welcome back</p>
        <p className="text-[24px] leading-[32px] font-bold">
          {user?.first_name || 'User'} {user?.last_name || ''}
        </p>
      </div>
    </motion.div>
  );
};

export default WelcomeBanner;
